module.exports = __webpack_public_path__ + "static/media/00_lab_monitor_card.7a2784b6.png";